import './Alert.css'
import cx from 'classnames'
import { InfoIcon, TriangleExclamationIcon, CheckCircleIcon } from '../icons'

type AlertType = 'info' | 'error' | 'warning' | 'success'

const alertTypeClasses: Record<AlertType, string> = {
  info: 'alert-info',
  error: 'alert-error',
  warning: 'alert-warning',
  success: 'alert-success'
}

const alertSizeClasses = {
  sm: 'alert-sm'
}

export function Alert({
  children,
  type,
  className,
  sizeType = 'sm'
}: {
  children: React.ReactNode
  type: AlertType
  className?: string
  sizeType?: 'sm'
}) {
  return (
    <div
      className={cx('alert-base', alertTypeClasses[type], alertSizeClasses[sizeType], className)}
    >
      <div>
        {type === 'info' && <InfoIcon className="alert-icon" />}
        {type === 'error' && <TriangleExclamationIcon className="alert-icon-error" />}
        {type === 'warning' && <TriangleExclamationIcon className="alert-icon-warning" />}
        {type === 'success' && <CheckCircleIcon className="alert-icon-success" />}
      </div>
      <div>{children}</div>
    </div>
  )
}
